import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";

import { AutorizacionesAccordionEfector } from "./Accordions/AutorizacionesAccordionEfector";
import { AutorizacionesAccordionPrescriptor } from "./Accordions/AutorizacionesAccordionPrescriptor";
import { AutorizacionesAccordionMateriales } from "./Accordions/AutorizacionesAccordionMateriales";
import LetterX from "../UI/LetterX";

import {
  getEfectorInstitucional,
  getEfectorProfesional,
  deletePractica,
  setearValorEnPractica,
} from "../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_COBRA_COSEGURO, AUTORIZACIONES_PRACTICAS_ESTADOS, AUTORIZACIONES_SOLICITUDES_ESTADOS, AUTORIZACIONES_TIPO_EFECTOR, TIPOS_AUTORIZACIONES } from "../../../utils/constants";
// import { AutorizacionesAccordionDocumentacionPractica } from "./Accordions/AutorizacionesAccordionDocumentacionPractica";
import { PracticaNroAutorizacion } from "./PracticaNroAutorizacion";

const PracticaTipoSolPractica = (props) => {
  const dispatch = useDispatch();
  const { estadoSolicitudes, solicitudSeleccionada } = useSelector((state) => state.autorizaciones);
  // const [datosCompletosDocumentacionPractica, setDatosCompletosDocumentacionPractica] = useState(false);

  const disabledProp = (props.esDenunciaInternacion ||
    parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA ||
    parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES ||
    props.disabled) ? true : false;

  const marginEnd = props.practica?.nroAutorizacion ? 75 : 25;

  console.log("props.desdeAuditar", props.desdeAuditar);
  console.log("props.disabledAuditar", props.disabledAuditar);
  console.log("solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE", solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE);
  console.log("solicitudSeleccionada.idEstadoSolicitud", solicitudSeleccionada.idEstadoSolicitud);

  const disabledSurge = props.desdeAuditar ?
    !props.desdeAuditar || props.disabledAuditar
    || (solicitudSeleccionada.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE &&
      solicitudSeleccionada.idEstadoSolicitud !== undefined)
    : false;

  return (
    <div style={{ marginBottom: "2.8rem", marginRight: 40 }}>
      <div
        style={{
          padding: "1rem",
          marginTop: "1.0rem",
          marginBottom: props.desdeAuditar ? 0 : "0.5rem",
          marginRight: "1rem",
          marginLeft: "1rem",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {!disabledProp
          && (props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE
            || props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION)
          && (
            <LetterX
              deleteFunction={() => {
                dispatch(deletePractica(props.practica?.idCodNom));
              }}
              styles={{
                cursor: "pointer",
                position: "relative",
                top: "0.25rem",
                marginRight: "0.5rem",
              }}
            />
          )}
        {props.desdeAuditar && <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, width: "90%" }}>
          {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
        </Typography>}
        {(props.practica?.practica?.nivelAutorizacion === 0 || props.practica?.practica?.nivelAutorizacion === 1 ||
          props.practica?.practica?.nivelautorizacion === 0 || props.practica?.practica?.nivelautorizacion === 1
        )
          && !props.desdeAuditar && <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, width: "90%", color: "#10b04b" }}>
            {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
          </Typography>}
        {(props.practica?.practica?.nivelAutorizacion === 2 || props.practica?.practica?.nivelAutorizacion === 3 ||
          props.practica?.practica?.nivelautorizacion === 2 || props.practica?.practica?.nivelautorizacion === 3
        )
          && !props.desdeAuditar && <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, width: "90%", color: "#c43e1f" }}>
            {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
          </Typography>}
        <TextField
          style={{
            width: "10%",
            position: "relative",
            bottom: "1.2rem",
            marginTop: 20,
            minWidth: 65,
          }}
          variant="outlined"
          type="number"
          label="Cantidad"
          value={props.cantidad}
          disabled={disabledProp || (props.practica?.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE
            && props.practica?.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION)
          }
          onChange={(e) => {
            props.setCantidad(e.target.value);
            dispatch(
              setearValorEnPractica(
                props.practica?.idCodNom,
                "cant",
                Number(e.target.value)
              )
            );
          }}
          error={props.cantidad <= 0}
          helperText={props.cantidad <= 0 && "Debe ser mayor a 0."}
        />
      </div>
      <>
        {props.desdeAuditar && (
          <RadioGroup
            row
            style={{ justifyContent: "space-evenly" }}
            value={props.practica?.idEstadoPractica?.toString()}
            onChange={(e) => {
              dispatch(
                setearValorEnPractica(
                  props.practica?.idCodNom,
                  "idEstadoPractica",
                  parseInt(e.target.value)
                )
              );

              if (props.evaluarPracticasMateriales && parseInt(e.target.value) === AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO)
                props.evaluarPracticasMateriales();
            }}
          >
            <FormControlLabel
              label={"Autorizada"}
              value={AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO.toString()}
              control={<Radio />}
              disabled={disabledProp || props.disabledAuditar}
            />
            <FormControlLabel
              label={"Gestión"}
              value={AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION.toString()}
              control={<Radio />}
              disabled={disabledProp || props.disabledAuditar}
            />
            <FormControlLabel
              label={"Rechazada"}
              value={AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO.toString()}
              control={<Radio />}
              disabled={disabledProp || props.disabledAuditar}
            />
          </RadioGroup>
        )}
        <FormGroup row>
          <FormControlLabel
            style={{
              marginLeft: 50,
              marginTop: !props.desdeAuditar && -50,
              marginBottom: marginEnd,
              // marginBottom: props.practica?.nroLote &&
              //                 props.practica?.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.COBRA_CAB 
              //                   ? 75 
              //                   : 25,
            }}
            control={
              <Checkbox
                checked={!!props.practica?.recuperoSur}
                disabled={disabledSurge}
                onChange={(e) => {
                  dispatch(
                    setearValorEnPractica(
                      props.practica?.idCodNom,
                      "recuperoSur",
                      e.target.checked
                    )
                  );
                }}
              />
            }
            label="SURGE"
          />
          {props.practica?.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.COBRA_CAB &&
            props.practica?.nroLote
            ?
            <FormControlLabel
              style={{
                marginLeft: 50,
                marginTop: !props.desdeAuditar && -50,
                marginBottom: marginEnd,
              }}
              control={
                <Checkbox
                  checked={props.practica?.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.COBRA_CAB}
                  disabled
                />
              }
              label="Práctica Abonada en CAB"
            />
            :
            <FormControlLabel
              style={{
                marginLeft: 50,
                marginTop: !props.desdeAuditar && -50,
                marginBottom: marginEnd,
                // marginBottom: 25,
              }}
              control={
                <Checkbox
                  checked={props.practica?.idCobraCoseguro === AUTORIZACIONES_COBRA_COSEGURO.COBRA_CAB}
                  disabled
                />
              }
              label="Requiere cobro en CAB"
            />
          }
          {solicitudSeleccionada?.idPresupuesto !== null &&
            <Grid item xs={4} style={{ color: 'black', marginTop: "-7px", textAlign: "right", marginLeft: "270px" }}>
              <h5>Valor Presupuesto: $ {props.practica?.valorUnitarioPresupuesto?.toFixed(2) ?? 0}</h5>
            </Grid>}
        </FormGroup>

        {props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO &&
          props.practica?.nroAutorizacion &&
          <PracticaNroAutorizacion nroAutorizacion={props.practica?.nroAutorizacion} />
        }
      </>
      {/* <AutorizacionesAccordionDocumentacionPractica
        idCodNom={props.practica?.idCodNom}
        datosCompletos={datosCompletosDocumentacionPractica}
        setDatosCompletos={setDatosCompletosDocumentacionPractica}
      /> */}
      <AutorizacionesAccordionEfector
        idTipoEfector={
          props.conInternacion && props.practica.copiaEfectorInstitucional
            ? AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL_Y_PROFESIONAL
            : AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL
        }
        practica={props.practica}
        disabled={props.disabled || solicitudSeleccionada?.idEstadoSolicitud ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA
          || solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO
        }
        preEfector={
          !!props.practica.idCartillaPrestador
            ? props.practica.cartillaPrestadores?.atiendeCentroPropio
              ? {
                domicilio: props.practica.cartillaPrestadores.centroMedicoPropio.direccion,
                localidad: { descripcion_localidad: '' },
                provincia: { descripcion_provincia: '' },
                cartillaPrestadores: { prestador: { nombreApellido: props.practica.cartillaPrestadores.centroMedicoPropio.descripcionCentro } }
              }
              : props.practica.efectorInstitucional
                ? props.practica.efectorInstitucional
                : {
                  domicilio: 'SIN DOMICILIO',
                  localidad: { descripcion_localidad: '' },
                  provincia: { descripcion_provincia: '' },
                  cartillaPrestadores: { prestador: { nombreApellido: props.practica.cartillaPrestadores?.prestador?.nombreApellido } }
                }
            : null
        }
        desdeAuditar={props.desdeAuditar}
        emailEfectorI={props.practica.emailEfectorI}
        celularEfectorI={props.practica.celularEfectorI}
        emailEfectorIError={props.practica.emailEfectorIError}
        celularEfectorIError={props.practica.celularEfectorIError}
        setearEfector={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica?.idCodNom,
              "idEfectorFacturacion",
              idEfector
            )
          );
        }}
        setearEfectorP={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica?.idCodNom,
              "idCartillaPrestador",
              idEfector
            )
          );
        }}
        setearContactoEfectorI={props.handleInputContactosEfectorIChange}
        setearCopiarEfectorF={(value) => {
          dispatch(
            setearValorEnPractica(
              props.practica.idCodNom,
              "copiaEfectorInstitucional",
              value
            )
          );
        }}
        conInternacion={props.conInternacion}
        traerEfectores={getEfectorInstitucional}
        estaCorrecto={props.tieneEfectorInstitucional}
        esDenunciaInternacion={props.esDenunciaInternacion}
      />
      {props.conInternacion && !props.practica.copiaEfectorInstitucional && (
        <AutorizacionesAccordionEfector
          idTipoEfector={AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL}
          disabled={props.disabled || solicitudSeleccionada?.idEstadoSolicitud ===
            AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA}
          practica={props.practica}
          preEfector={
            !!props.practica.idPrestador
              ? props.practica.efectorProfesional
              : null
          }
          setearEfector={(idEfector) => {
            dispatch(
              setearValorEnPractica(
                props.practica?.idCodNom,
                "idPrestador",
                idEfector
              )
            );
          }}
          traerEfectores={getEfectorProfesional}
          estaCorrecto={props.tieneIdEfectorProfesional}
          esDenunciaInternacion={props.esDenunciaInternacion}
        />
      )}
      <AutorizacionesAccordionPrescriptor
        disabled={props.disabled || solicitudSeleccionada?.idEstadoSolicitud ===
          AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA}
        prePrescriptor={
          !!props.practica.idPrescriptor ? props.practica.prescriptor : null
        }
        setearEfector={(idEfector) => {
          dispatch(
            setearValorEnPractica(
              props.practica.idCodNom,
              "idPrescriptor",
              idEfector
            )
          );
        }}
        estaCorrecto={props.tieneIdPrescriptor}
        esDenunciaInternacion={props.esDenunciaInternacion}
        practica={props.practica}
      />
      {props.mostrarMateriales && (
        <AutorizacionesAccordionMateriales
          practica={props.practica}
          disabled={props.disabled}
          desdeAuditar={props.desdeAuditar}
          estaCorrecto={props.tieneMinimoUnMaterial}
          esDenunciaInternacion={props.esDenunciaInternacion}
          idTipoSolicitud={solicitudSeleccionada?.idTipoSolicitud}
          evaluarPracticasMateriales={props.evaluarPracticasMateriales}
          filtros={props.filtros}
        />
      )}
    </div>
  );
};

export default PracticaTipoSolPractica;
